module.exports = __webpack_public_path__ + "img/england.ad8b30d8.png";